import { render, staticRenderFns } from "./CreateLeadHeader.vue?vue&type=template&id=6d3c134b&"
import script from "./CreateLeadHeader.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports